export default {
  uiSize: 1920,
  equipmentEnd: "pc",
  version: "1.1.13",
};
